import { render, staticRenderFns } from "./ImportarProcessoIPM.vue?vue&type=template&id=2819f57b&scoped=true"
import script from "./ImportarProcessoIPM.vue?vue&type=script&lang=js"
export * from "./ImportarProcessoIPM.vue?vue&type=script&lang=js"
import style0 from "./ImportarProcessoIPM.vue?vue&type=style&index=0&id=2819f57b&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2819f57b",
  null
  
)

export default component.exports